import { useCallback } from 'react';

import { useDeletePintoWriterCampaignMutation } from '../core/graphql/operation-hooks';

const useMutationDeletePintoWriterCampaign = () => {
  const [mutateDeletePintoWriterCampaign, { loading: isLoadingMutateDeletePintoWriterCampaign }] = useDeletePintoWriterCampaignMutation();

  const onMutateDeletePintoWriterCampaign = useCallback(
    (productCampaignId: string) => {
      const variables = { productCampaignId };
      return mutateDeletePintoWriterCampaign({
        variables,
        refetchQueries: ['PintoWriterCampaigns', 'PintoWriterCampaign'],
      });
    },
    [mutateDeletePintoWriterCampaign],
  );

  return {
    onMutateDeletePintoWriterCampaign,
    isLoadingMutateDeletePintoWriterCampaign,
  };
};

export default useMutationDeletePintoWriterCampaign;
